<script lang="ts">
import type { Ref } from "vue";
import { defineComponent, ref, toRefs, watch } from "vue";
import { useUserSession } from "../../stores/userSession";
import { Closure } from "../../models/closure";

export function modelEvents() {
    return {
        onBeforeCreate(closure: Closure) {
            const { user } = useUserSession();
            closure.startDate = closure.startDate.startOf("minute");
            closure.endDate = closure.endDate.startOf("minute");
            if (user === null) throw new Error("No owner selected");
            closure.owner = user.owner;
        },

        onBeforeEdit(closure: Closure) {
            const { user } = useUserSession();
            closure.startDate = closure.startDate.startOf("minute");
            closure.endDate = closure.endDate.startOf("minute");
            if (user === null) throw new Error("No owner selected");
            closure.owner = user.owner;
        },
    };
}

export default defineComponent({
    props: {
        form: {
            type: Closure,
            required: true,
        },
    },
    setup(props: any) {
        const { form: closure } = toRefs(props);

        const isWholeDay: Ref<boolean> = ref(false);

        watch(isWholeDay, () => {
            if (isWholeDay.value) {
                (closure.value as Closure).startTime = "00:00";
                (closure.value as Closure).endTime = "23:59";
            }
        });

        return {
            isWholeDay,
            closure,
        };
    },
});
</script>

<template>
    <VFlex :flex-direction="'column'">
        <VFieldModel v-model="closure" property="type"></VFieldModel>
        <VFlex flex-direction="row" align-items="center" justify-content="space-around">
            <VFieldModel v-model="closure" property="startDate"></VFieldModel>
            <VFieldModel v-model="closure" property="endDate"></VFieldModel>
        </VFlex>
        <VFieldModel v-model="closure" property="daysOfWeek"> </VFieldModel>
        <VCheckbox v-model="isWholeDay"><Translate>.isWholeDay</Translate></VCheckbox>
        <VFlex
            v-if="!isWholeDay"
            flex-direction="row"
            align-items="center"
            justify-content="space-around">
            <VFieldModel
                v-slot="{ field: fieldStartTime }"
                v-model="closure"
                property="startTime">
                <VInputTime
                    v-model="fieldStartTime.value"
                    to-string
                    :min-hour="0"
                    :max-hour="23"></VInputTime>
            </VFieldModel>
            <VIcon icon="arrow_right_alt"></VIcon>
            <VFieldModel
                v-slot="{ field: fieldEndTime }"
                v-model="closure"
                property="endTime">
                <VInputTime
                    v-model="fieldEndTime.value"
                    to-string
                    :min-hour="0"
                    :max-hour="23"></VInputTime>
            </VFieldModel>
        </VFlex>
        <VFieldModel v-model="closure" property="comment"></VFieldModel>
    </VFlex>
</template>

<style lang="scss" scoped>
*:not(:last-of-type) {
    margin-bottom: 0.5rem;
}
</style>